import React, { useEffect, useState } from 'react';
import { Table, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useStoreActions, useStoreState } from '../../../store';
import { createUseStyles } from 'react-jss';
import { SearchBar } from '../../shared/SearchBar';
import { defaultAssetTableSortComparator, formattedTenantLinksList } from '../utils';
import { escapeRegexChars } from '../../../utils/regex';
import type { PartnerTenant } from '@shipium-corp/shipium-ts-types';

const useStyles = createUseStyles({
  tableStyles: {
    '&& table > .ant-table-thead > tr > th': {
      fontWeight: 'bold',
    },
  },
});

const { Text } = Typography;

export interface TenantSelectTableProps {
  selectedTenantIds?: string[];
  allowMultiple?: boolean;
  onSelect?: (selectedTenantId: string) => void;
  pageSize?: number;
}
export const TenantSelectTable = ({ selectedTenantIds, allowMultiple, onSelect, pageSize }: TenantSelectTableProps) => {
  const tenants = useStoreState((state) => state.tenant.tenants);
  const fetchTenants = useStoreActions((actions) => actions.tenant.fetchTenants);
  const [searchBarText, setSearchBarText] = useState('');
  const classes = useStyles();

  useEffect(() => {
    fetchTenants(undefined);
  }, [fetchTenants]);

  const onSelectChange = (
    record: PartnerTenant,
    selected: boolean,
    selectedRows: PartnerTenant[],
    nativeEvent: Event,
  ) => {
    if (typeof onSelect === 'function') {
      onSelect(record.tenantId!);
    }
  };

  const columns: ColumnsType<PartnerTenant> = [
    {
      title: 'Tenant',
      key: 'tenantId',
      render: (val: PartnerTenant) => {
        return (
          <div>
            <div style={{ color: '#000' }}>{val.name}</div>
            <div>
              <Text type={'secondary'}>Unique Identifier: {val.partnerProvidedId}</Text>
            </div>
          </div>
        );
      },
    },
    {
      title: 'Linked Configuration',
      key: 'partnerProvidedId',
      render: (val: PartnerTenant) => {
        return formattedTenantLinksList(val as any);
      },
    },
    // {
    //   title: 'Partner Provided Id',
    //   key: 'partnerProvidedId',
    //   render: (val: Tenant) => {
    //     return val.partnerProvidedId || '';
    //   }
    // },
  ];

  const allData = Object.values(tenants)
    .sort(defaultAssetTableSortComparator)
    .map((tenant: any) => {
      tenant.key = tenant.tenantId;
      return tenant;
    }) as any;

  const data = allData.filter((tenant: PartnerTenant) => {
    const regex = new RegExp(escapeRegexChars(searchBarText), 'ig');
    return (
      regex.test(tenant.name!) ||
      regex.test(tenant.partnerProvidedId!) ||
      regex.test(tenant.taxIdentificationNumber || '')
    );
  });

  return (
    <div>
      <div style={{ paddingBottom: '5px' }}>
        <SearchBar setSearchBarValue={setSearchBarText} placeholder={'Search Tenants'} />
      </div>
      <Table
        size={'small'}
        rowSelection={{
          ...(selectedTenantIds ? { selectedRowKeys: selectedTenantIds } : {}),
          hideSelectAll: true,
          type: allowMultiple ? 'checkbox' : 'radio',
          onSelect: onSelectChange,
        }}
        columns={columns}
        dataSource={data}
        bordered={false}
        pagination={{ pageSize: pageSize ?? 10, showSizeChanger: false }}
        className={classes.tableStyles}
      />
    </div>
  );
};
